import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        root: {
            width: '100%',
        },
        tableWrapper: {
            height: '33%',
            paddingBottom: theme.spacing(4),
        },
        headerTitle: {
            color: theme.palette.secondary[900],
            fontWeight: theme.typography.h1.fontWeight,
            fontSize: theme.typography.h1.fontSize,
            paddingBottom: theme.spacing(3),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        filterWrapper: {
            marginBottom: theme.spacing(3),
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
        },
    }
})

export default useStyles
